<script lang="ts" setup>
const model = defineModel<string | number | undefined>();

const inputRef = ref<HTMLInputElement | null>(null);

const focus = () => {
  inputRef.value?.focus();
};

defineExpose({
  focus,
});
</script>

<template>
  <input
    ref="inputRef"
    v-model="model"
    v-bind="$attrs"
  >
</template>
